/**
 * Created by richard on 7/17/14.
 */
var schoolSubcategoriesModel = angular.module('schoolSubcategoriesModel', ['schoolModel']);
schoolSubcategoriesModel.factory('SchoolSubcategoriesModelFactory', function(ApplicationService, RestService, SchoolModelFactory){
    var SchoolSubcategoriesModel = function(){
        this.endpoint = '/SchoolSubcategories';
        this.primaryKey = "recordID";
    }
    SchoolSubcategoriesModel.prototype = new SchoolModelFactory();
    SchoolSubcategoriesModel.prototype.parent = SchoolModelFactory.prototype;
    SchoolSubcategoriesModel.prototype.resolveData = function(schoolID)
    {
        var parent = this;
        return this.parent.resolveData.apply(this, arguments).then(function(data)
        {
            parent.data = data[0].data;
        });

    }
    SchoolSubcategoriesModel.prototype.new = function()
    {
        var schoolID = this.getSchoolID();
        var subcat = {schoolID: schoolID, subcategory: '', active: 1, deleted: ''};
        return subcat;

    }
    return SchoolSubcategoriesModel;
});


schoolSubcategoriesModel.service('SchoolSubcategoriesModelService', function(SchoolSubcategoriesModelFactory){
    var schoolSubcategoriesModel = new SchoolSubcategoriesModelFactory();
    return schoolSubcategoriesModel;
});


